export type SiteConfig = typeof siteConfig
export const siteConfig = {
    name: "Wish Potion ",
    slogan: "slogan",
    icon: "/favicon.ico",
    appleIcon: "/apple-touch-icon.png",
    gameIframe: "https://html.itch.zone/html/11747744/index.html",
    domain: "wishpotiongame.online",
    gaId: "G-8MWFFR7T8G",
    navbarItems: [
        {
            title: "title",
             href: "/",
        }
    ],
}
